// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 30 ? "23b2023c" : chunkId) + "." + {"30":"8a82fe87e2fb1b9d","275":"213c066b19f8a7e6"}[chunkId] + ".js";
};